import { render, staticRenderFns } from "./inventory-details.vue?vue&type=template&id=23f6ac2e"
import script from "./inventory-details.vue?vue&type=script&lang=ts"
export * from "./inventory-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports